module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-05.0e81faef.png";